import { render, staticRenderFns } from "./PricingTray.vue?vue&type=template&id=f886b6ac&lang=html&"
import script from "./PricingTray.vue?vue&type=script&lang=js&"
export * from "./PricingTray.vue?vue&type=script&lang=js&"
import style0 from "./PricingTray.vue?vue&type=style&index=0&id=f886b6ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports